export const desireSchema = {
    type: 'object',
    properties: {
        desireId: {
            type: 'integer',
            idField: true
        },
        customerId: {
            type: 'integer'
        },
        weight: {
            type: ['object','null'],
            properties: {
                minimum: {type: 'number', minimum: 0},
                maximum: {type: 'number', minimum: 0}
            },
            minProperties: 1,
            additionalProperties: false
        },
        shape: {
            type: ['array','null'],
            items: {
                type: 'string'
            }
        },
        colour: {
            type: ['array','null'],
            items: {
                type: 'string'
            }
        },
        clarity: {
            type: ['array','null'],
            items: {
                type: 'string'
            }
        },
        cut: {
            type: ['array','null'],
            items: {
                type: 'string'
            }
        },
        polish: {
            type: ['array','null'],
            items: {
                type: 'string'
            }
        },
        symmetry: {
            type: ['array','null'],
            items: {
                type: 'string'
            }
        },
        fluorescence: {
            type: ['array','null'],
            items: {
                type: 'string'
            }
        },
        lwRatio: {
            type: ['object','null'],
            properties: {
                minimum: {type: 'number', minimum: 0},
                maximum: {type: 'number', minimum: 0}
            },
            minProperties: 1,
            additionalProperties: false
        },
        depthPercent: {
            type: ['object','null'],
            properties: {
                minimum: {type: 'number', minimum: 0},
                maximum: {type: 'number', minimum: 0}
            },
            minProperties: 1,
            additionalProperties: false
        },
        tablePercent: {
            type: ['object','null'],
            properties: {
                minimum: {type: 'number', minimum: 0},
                maximum: {type: 'number', minimum: 0}
            },
            minProperties: 1,
            additionalProperties: false
        },
        price: {
            type: ['object','null'],
            properties: {
                minimum: {type: 'number', minimum: 0},
                maximum: {type: 'number', minimum: 0}
            },
            minProperties: 1,
            additionalProperties: false
        },
        quantity: {
            type: 'integer',
            minimum: 1
        },
        shortTerm: {
            type: 'boolean'
        },
        status: {
            type: 'string'
        },
        remarks: {
            type: ['string','null'],
            maxLength: 500
        }
    },
    required: ['customerId','quantity','shortTerm','status'],
    minProperties: 5,
    additionalProperties: false,
    removeNulls: true
}